import { create } from "zustand";

const useAuthStore = create((set) => ({
  token: undefined,
  setToken: (newToken) => set({ token: newToken }),
  removeToken: () => set({ token: undefined }),
}));

export default useAuthStore;
